import React, { forwardRef } from 'react'
import { Link } from 'react-router-dom'
import Label from './Label'

export const Button = forwardRef((props, ref) => (
  <Label
    interactive
    as={props.to ? Link : props.href ? 'a' : undefined}
    ref={ref}
    {...props}
    className={'button ' + (props.className || '')}
  />
))

export default Button
